/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createSurveyHealthAssessment = /* GraphQL */ `
  mutation CreateSurveyHealthAssessment(
    $input: CreateSurveyHealthAssessmentInput!
    $condition: ModelSurveyHealthAssessmentConditionInput
  ) {
    createSurveyHealthAssessment(input: $input, condition: $condition) {
      id
      survey
      companyId
      companyName
      subjectId
      testId
      surveyTemplate
      consultant
      gender
      testDate
      bookingExperience
      onTime
      discussResults
      lifestyleChange
      professionalism
      experience
      recommend
      participate
      comment
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSurveyHealthAssessment = /* GraphQL */ `
  mutation UpdateSurveyHealthAssessment(
    $input: UpdateSurveyHealthAssessmentInput!
    $condition: ModelSurveyHealthAssessmentConditionInput
  ) {
    updateSurveyHealthAssessment(input: $input, condition: $condition) {
      id
      survey
      companyId
      companyName
      subjectId
      testId
      surveyTemplate
      consultant
      gender
      testDate
      bookingExperience
      onTime
      discussResults
      lifestyleChange
      professionalism
      experience
      recommend
      participate
      comment
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSurveyHealthAssessment = /* GraphQL */ `
  mutation DeleteSurveyHealthAssessment(
    $input: DeleteSurveyHealthAssessmentInput!
    $condition: ModelSurveyHealthAssessmentConditionInput
  ) {
    deleteSurveyHealthAssessment(input: $input, condition: $condition) {
      id
      survey
      companyId
      companyName
      subjectId
      testId
      surveyTemplate
      consultant
      gender
      testDate
      bookingExperience
      onTime
      discussResults
      lifestyleChange
      professionalism
      experience
      recommend
      participate
      comment
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSurveyCompanyContact = /* GraphQL */ `
  mutation CreateSurveyCompanyContact(
    $input: CreateSurveyCompanyContactInput!
    $condition: ModelSurveyCompanyContactConditionInput
  ) {
    createSurveyCompanyContact(input: $input, condition: $condition) {
      id
      companyId
      pulseId
      companyName
      participants
      service
      support
      quality
      professionalism
      impact
      valueformoney
      recommend
      mentalhealth
      fluvouchers
      onlineassessment
      promotions
      stressmanagement
      wellbeingdevelopment
      feedback
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSurveyCompanyContact = /* GraphQL */ `
  mutation UpdateSurveyCompanyContact(
    $input: UpdateSurveyCompanyContactInput!
    $condition: ModelSurveyCompanyContactConditionInput
  ) {
    updateSurveyCompanyContact(input: $input, condition: $condition) {
      id
      companyId
      pulseId
      companyName
      participants
      service
      support
      quality
      professionalism
      impact
      valueformoney
      recommend
      mentalhealth
      fluvouchers
      onlineassessment
      promotions
      stressmanagement
      wellbeingdevelopment
      feedback
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSurveyCompanyContact = /* GraphQL */ `
  mutation DeleteSurveyCompanyContact(
    $input: DeleteSurveyCompanyContactInput!
    $condition: ModelSurveyCompanyContactConditionInput
  ) {
    deleteSurveyCompanyContact(input: $input, condition: $condition) {
      id
      companyId
      pulseId
      companyName
      participants
      service
      support
      quality
      professionalism
      impact
      valueformoney
      recommend
      mentalhealth
      fluvouchers
      onlineassessment
      promotions
      stressmanagement
      wellbeingdevelopment
      feedback
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSurveyCompany2022 = /* GraphQL */ `
  mutation CreateSurveyCompany2022(
    $input: CreateSurveyCompany2022Input!
    $condition: ModelSurveyCompany2022ConditionInput
  ) {
    createSurveyCompany2022(input: $input, condition: $condition) {
      id
      surveyId
      companyName
      event
      communication
      impact
      performance
      valueformoney
      feedback
      participants
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSurveyCompany2022 = /* GraphQL */ `
  mutation UpdateSurveyCompany2022(
    $input: UpdateSurveyCompany2022Input!
    $condition: ModelSurveyCompany2022ConditionInput
  ) {
    updateSurveyCompany2022(input: $input, condition: $condition) {
      id
      surveyId
      companyName
      event
      communication
      impact
      performance
      valueformoney
      feedback
      participants
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSurveyCompany2022 = /* GraphQL */ `
  mutation DeleteSurveyCompany2022(
    $input: DeleteSurveyCompany2022Input!
    $condition: ModelSurveyCompany2022ConditionInput
  ) {
    deleteSurveyCompany2022(input: $input, condition: $condition) {
      id
      surveyId
      companyName
      event
      communication
      impact
      performance
      valueformoney
      feedback
      participants
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSurveyWorkshop = /* GraphQL */ `
  mutation CreateSurveyWorkshop(
    $input: CreateSurveyWorkshopInput!
    $condition: ModelSurveyWorkshopConditionInput
  ) {
    createSurveyWorkshop(input: $input, condition: $condition) {
      id
      company
      name
      date
      participants
      isDeleted
      surveyWorkshopFeedback {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSurveyWorkshop = /* GraphQL */ `
  mutation UpdateSurveyWorkshop(
    $input: UpdateSurveyWorkshopInput!
    $condition: ModelSurveyWorkshopConditionInput
  ) {
    updateSurveyWorkshop(input: $input, condition: $condition) {
      id
      company
      name
      date
      participants
      isDeleted
      surveyWorkshopFeedback {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSurveyWorkshop = /* GraphQL */ `
  mutation DeleteSurveyWorkshop(
    $input: DeleteSurveyWorkshopInput!
    $condition: ModelSurveyWorkshopConditionInput
  ) {
    deleteSurveyWorkshop(input: $input, condition: $condition) {
      id
      company
      name
      date
      participants
      isDeleted
      surveyWorkshopFeedback {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSurveyDigitalVoucher = /* GraphQL */ `
  mutation CreateSurveyDigitalVoucher(
    $input: CreateSurveyDigitalVoucherInput!
    $condition: ModelSurveyDigitalVoucherConditionInput
  ) {
    createSurveyDigitalVoucher(input: $input, condition: $condition) {
      id
      voucherCacheId
      company
      experience
      findpharmacy
      pharmacyExperience
      pharmacy
      communication
      previousVoucher
      recommend
      easierToUse
      comment
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSurveyDigitalVoucher = /* GraphQL */ `
  mutation UpdateSurveyDigitalVoucher(
    $input: UpdateSurveyDigitalVoucherInput!
    $condition: ModelSurveyDigitalVoucherConditionInput
  ) {
    updateSurveyDigitalVoucher(input: $input, condition: $condition) {
      id
      voucherCacheId
      company
      experience
      findpharmacy
      pharmacyExperience
      pharmacy
      communication
      previousVoucher
      recommend
      easierToUse
      comment
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSurveyDigitalVoucher = /* GraphQL */ `
  mutation DeleteSurveyDigitalVoucher(
    $input: DeleteSurveyDigitalVoucherInput!
    $condition: ModelSurveyDigitalVoucherConditionInput
  ) {
    deleteSurveyDigitalVoucher(input: $input, condition: $condition) {
      id
      voucherCacheId
      company
      experience
      findpharmacy
      pharmacyExperience
      pharmacy
      communication
      previousVoucher
      recommend
      easierToUse
      comment
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSurveyWorkshopFeedback = /* GraphQL */ `
  mutation CreateSurveyWorkshopFeedback(
    $input: CreateSurveyWorkshopFeedbackInput!
    $condition: ModelSurveyWorkshopFeedbackConditionInput
  ) {
    createSurveyWorkshopFeedback(input: $input, condition: $condition) {
      id
      trainer
      rateWorkshop
      workshopContent
      increaseUnderstanding
      usefulPrinciplesTechniques
      elementsChangeInclude
      recommend
      feedback
      surveyWorkshop {
        id
        company
        name
        date
        participants
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSurveyWorkshopFeedback = /* GraphQL */ `
  mutation UpdateSurveyWorkshopFeedback(
    $input: UpdateSurveyWorkshopFeedbackInput!
    $condition: ModelSurveyWorkshopFeedbackConditionInput
  ) {
    updateSurveyWorkshopFeedback(input: $input, condition: $condition) {
      id
      trainer
      rateWorkshop
      workshopContent
      increaseUnderstanding
      usefulPrinciplesTechniques
      elementsChangeInclude
      recommend
      feedback
      surveyWorkshop {
        id
        company
        name
        date
        participants
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSurveyWorkshopFeedback = /* GraphQL */ `
  mutation DeleteSurveyWorkshopFeedback(
    $input: DeleteSurveyWorkshopFeedbackInput!
    $condition: ModelSurveyWorkshopFeedbackConditionInput
  ) {
    deleteSurveyWorkshopFeedback(input: $input, condition: $condition) {
      id
      trainer
      rateWorkshop
      workshopContent
      increaseUnderstanding
      usefulPrinciplesTechniques
      elementsChangeInclude
      recommend
      feedback
      surveyWorkshop {
        id
        company
        name
        date
        participants
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSurveyCoaching = /* GraphQL */ `
  mutation CreateSurveyCoaching(
    $input: CreateSurveyCoachingInput!
    $condition: ModelSurveyCoachingConditionInput
  ) {
    createSurveyCoaching(input: $input, condition: $condition) {
      id
      company
      name
      date
      participants
      isDeleted
      surveyCoachingFeedback {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSurveyCoaching = /* GraphQL */ `
  mutation UpdateSurveyCoaching(
    $input: UpdateSurveyCoachingInput!
    $condition: ModelSurveyCoachingConditionInput
  ) {
    updateSurveyCoaching(input: $input, condition: $condition) {
      id
      company
      name
      date
      participants
      isDeleted
      surveyCoachingFeedback {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSurveyCoaching = /* GraphQL */ `
  mutation DeleteSurveyCoaching(
    $input: DeleteSurveyCoachingInput!
    $condition: ModelSurveyCoachingConditionInput
  ) {
    deleteSurveyCoaching(input: $input, condition: $condition) {
      id
      company
      name
      date
      participants
      isDeleted
      surveyCoachingFeedback {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createSurveyCoachingFeedback = /* GraphQL */ `
  mutation CreateSurveyCoachingFeedback(
    $input: CreateSurveyCoachingFeedbackInput!
    $condition: ModelSurveyCoachingFeedbackConditionInput
  ) {
    createSurveyCoachingFeedback(input: $input, condition: $condition) {
      id
      rateCoaching
      benefitted
      connected
      actions
      expectations
      takeaway
      improve
      recommend
      feedback
      surveyCoaching {
        id
        company
        name
        date
        participants
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSurveyCoachingFeedback = /* GraphQL */ `
  mutation UpdateSurveyCoachingFeedback(
    $input: UpdateSurveyCoachingFeedbackInput!
    $condition: ModelSurveyCoachingFeedbackConditionInput
  ) {
    updateSurveyCoachingFeedback(input: $input, condition: $condition) {
      id
      rateCoaching
      benefitted
      connected
      actions
      expectations
      takeaway
      improve
      recommend
      feedback
      surveyCoaching {
        id
        company
        name
        date
        participants
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSurveyCoachingFeedback = /* GraphQL */ `
  mutation DeleteSurveyCoachingFeedback(
    $input: DeleteSurveyCoachingFeedbackInput!
    $condition: ModelSurveyCoachingFeedbackConditionInput
  ) {
    deleteSurveyCoachingFeedback(input: $input, condition: $condition) {
      id
      rateCoaching
      benefitted
      connected
      actions
      expectations
      takeaway
      improve
      recommend
      feedback
      surveyCoaching {
        id
        company
        name
        date
        participants
        isDeleted
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
